import React, { Component, Fragment } from "react";
import { getCurrencyFormat } from "../../../components/utils/currency";
import { Button } from "biologiatotal-ui";
import Icon from "../../../components/icon";
import "./footerBuy.scss";

class FooterBuy extends Component {
  render() {
    const {
      isNexting,
      onNext,
      onBack,
      disabled = false,
      disabledNext = false,
      sectionPayment = false,
      currentPrice
    } = this.props;
    const disabledButton = disabled ? "disabled" : "";
    const disabledButtonNext = disabledNext ? "disabled" : "";

    return (
      <div className="footer-buy">
        <div className="">
          <Button className={`footer-buy-icon ${disabledButton}`} onClick={onBack}>
            <Icon icon={"back"} height={16} width={16} className="footer-buy-back" />
          </Button>
        </div>
        <div className="">
          {sectionPayment ? (
            <Fragment>
              <span className="footer-buy-total">
                Total: <strong>{`${getCurrencyFormat(currentPrice, "R$ ", "0,00").replace(".", ",")}`}</strong>
              </span>
              <Button disabled={disabledButtonNext} className="footer-buy-button" loading={isNexting} onClick={onNext}>
                FINALIZAR
              </Button>
            </Fragment>
          ) : (
            <Button loading={isNexting} onClick={onNext} className="footer-buy-icon">
              <Icon icon={"back"} height={16} width={16} className="footer-buy-next" />
            </Button>
          )}
        </div>
      </div>
    );
  }
}

FooterBuy.displayName = "FooterBuy";

export default FooterBuy;
